'use client';

import React, { useState } from 'react';
import GameScreen from './GameScreen';
import CobwebSvg from './CobwebSvg';
import BloodDrips from './BloodDrips';

export default function LandingScreen() {
  const [gameStarted, setGameStarted] = useState(false);

  if (gameStarted) {
    return <GameScreen onRestart={() => setGameStarted(false)} />;
  }

  return (
    <div className="relative min-h-screen bg-horror flex flex-col items-center justify-center overflow-hidden">
      {/* Scanlines overlay */}
      <div className="scanlines absolute inset-0 z-10 pointer-events-none" aria-hidden="true" />

      {/* Candle vignette */}
      <div className="candle-vignette absolute inset-0 z-10 pointer-events-none" aria-hidden="true" />

      {/* Cobwebs in corners */}
      <CobwebSvg className="cobweb-tl z-20" />
      <CobwebSvg className="cobweb-tr z-20" />

      {/* Blood drips from top */}
      <BloodDrips />

      {/* Fog layers */}
      <div className="fog-layer z-10" aria-hidden="true" />
      <div className="fog-layer-2 z-10" aria-hidden="true" />

      {/* Main content */}
      <div className="relative z-30 flex flex-col items-center text-center px-6 max-w-lg mx-auto w-full">

        {/* Main title */}
        <h1
          className="font-horror text-5xl sm:text-6xl md:text-7xl blood-drip-title title-reveal-animate mb-2 leading-tight tracking-wide"
          style={{ letterSpacing: '0.05em' }}
        >
          SIAUBO
        </h1>
        <h1
          className="font-horror text-5xl sm:text-6xl md:text-7xl blood-drip-title title-reveal-animate mb-6 leading-tight tracking-wide"
          style={{ letterSpacing: '0.05em', animationDelay: '0.3s' }}
        >
          FABRIKAS
        </h1>

        {/* Subtitle */}
        <p className="font-sans text-2xl sm:text-3xl text-muted-foreground flicker-text mb-2 tracking-widest">
          Ar išdrįsi?
        </p>

        {/* Divider with blood drops */}
        <div className="flex items-center gap-3 mb-8 mt-2" aria-hidden="true">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-primary" />
          <span className="text-primary text-xl">🩸</span>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-primary" />
        </div>

        {/* Description */}
        <p className="text-muted-foreground text-base sm:text-lg mb-10 leading-relaxed fade-in-horror" style={{ animationDelay: '0.8s' }}>
          10 kambarių. 10 sprendimų. Viena klaida — ir viskas baigiasi.
        </p>

        {/* Start button */}
        <button
          onClick={() => setGameStarted(true)}
          className="start-btn font-sans text-xl sm:text-2xl text-white px-10 py-5 rounded-lg tracking-widest uppercase w-full max-w-xs cursor-pointer"
          aria-label="Pradėti žaidimą"
        >
          PRADĖTI ŽAIDIMĄ
        </button>

        {/* Warning text */}
        <p className="text-muted-foreground text-xs mt-6 flicker-slow opacity-60">
          2026 „Siaubo fabrikas". Visos teisės saugomos.
        </p>
      </div>

      {/* Bottom atmosphere */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent pointer-events-none z-10" aria-hidden="true" />
    </div>
  );
}